// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tableContainer___gKLIz{padding:16px;background:var(--white);border:1px solid var(--gray150);flex-grow:1}\n", "",{"version":3,"sources":["webpack://./src/routes/ManageTenants/routes/TenantGroup/components/TenantGroupTenants/TenantGroupTenants.css"],"names":[],"mappings":"AAAA,wBAAA,YAAA,CAEI,uBAAA,CACA,+BAAA,CACA,WAAA","sourcesContent":[".tableContainer {\n    padding: 16px;\n    background: var(--white);\n    border: 1px solid var(--gray150);\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": "tableContainer___gKLIz"
};
export default ___CSS_LOADER_EXPORT___;
